// extracted by mini-css-extract-plugin
export default {"appHeader":"Header_appHeader__z6bJx","titleWrapper":"Header_titleWrapper__si7HJ","pageTitle":"Header_pageTitle__T5vND"};